import type { SpreadLayoutTemplate } from './layout-types';

export const LINE_5_LAYOUT: SpreadLayoutTemplate = {
  id: 'line-5',
  family: 'line',
  cards: 5,
  description: 'Linea a cinque carte per scelte, timeline brevi e check-in strutturati.',
  supports_focus_overlay: false,
  variants: [
    {
      id: 'portrait',
      points: [
        { x: 12, y: 56, z: 1 },
        { x: 31, y: 51, z: 1 },
        { x: 50, y: 48, z: 1 },
        { x: 69, y: 51, z: 1 },
        { x: 88, y: 56, z: 1 },
      ],
    },
    {
      id: 'compact',
      points: [
        { x: 14, y: 58, z: 1 },
        { x: 32, y: 58, z: 1 },
        { x: 50, y: 58, z: 1 },
        { x: 68, y: 58, z: 1 },
        { x: 86, y: 58, z: 1 },
      ],
    },
    {
      id: 'wide',
      points: [
        { x: 16, y: 50, z: 1 },
        { x: 33, y: 48, z: 1 },
        { x: 50, y: 46, z: 1 },
        { x: 67, y: 48, z: 1 },
        { x: 84, y: 50, z: 1 },
      ],
    },
  ],
};
